import React, { useState, useEffect } from 'react';
import { Typography, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@material-ui/core';
import { get } from 'global/lib/lodash';
import { Loader } from '../../styles';
import { Button } from '../Button';

export default (props) => {
  const { onCancel, showDontAsk } = props;
  const [dontAsk, setDontAsk] = useState(false);
  const [loading, setLoading] = useState(false);

  const onOk = async () => {
    const ok = get(props, 'onOk', () => 0);
    await ok(showDontAsk ? dontAsk : undefined);
  };

  const open = !!get(props, 'title');

  useEffect(() => {
    if (!open) {
      setLoading(false);
    }
  }, [open]);

  const okayText = get(props, 'okayText', 'Ok');
  const cancelText = get(props, 'cancelText', 'Cancel');
  const maxWidth = get(props, 'maxWidth', 'xs');

  return (
    <Dialog disableBackdropClick disableEscapeKeyDown maxWidth={maxWidth} aria-labelledby="confirmation-dialog-title" open={open}>
      <DialogTitle id="confirmation-dialog-title">{get(props, 'title', '')}</DialogTitle>
      <DialogContent dividers>
        <Typography>{get(props, 'content')}</Typography>
      </DialogContent>
      <DialogActions>
        {showDontAsk && <FormControlLabel control={<Checkbox checked={dontAsk} onChange={(e) => setDontAsk(e.target.checked)} />} label="Don't show this again" />}
        <Button autoFocus onClick={onCancel} variant="default" color="primary">
          {cancelText}
        </Button>
        <Button onClick={onOk} color="primary" variant="contained" endIcon={loading ? <Loader /> : undefined}>
          {okayText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
